// src/apiService.js
import api from './api';

export async function sendRequest(url, method, data = {}) {
  try {
    const config = {
      method: method,
      url: url,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    if (method === 'GET') {
      config.params = data; // 将 data 作为查询参数
    } else {
      config.data = data; // 将 data 作为请求体
    }

    const response = await api(config);
    return response.data;
  } catch (error) {
    console.error(`Request failed: ${error}`);
    throw error;
  }
}

export async function loginByUnionid(loginInfo) {
  
  return await sendRequest('user/login/by/unionid', 'POST', loginInfo);
}

export async function getUserCoinInfoListPagedById(pageParams) {
  return await sendRequest('usercoin/get/coin/info/paged', 'GET',pageParams);
}

export async function getUserCoinCount() {
  return await sendRequest('usercoin/total/coin', 'GET');
}


export async function getUserEquipmentItems() {
  return await sendRequest('user/equipment/get', 'GET');
}

export async function getstudyData() {
  return await sendRequest('usercoin/get/study/data', 'GET');
}

export async function getPresignedUrl(fileObject) {
  
    return await sendRequest('oss/presigned/url', 'POST', fileObject);

}


// export async function applyByPinglunhuikui(pinglunhuikuiRewardApply) {
//   console.log('pinglunhuikuiRewardApply:', pinglunhuikuiRewardApply);
//   return await sendRequest('coin/reward/apply/by/pinglunhuikui', 'POST', pinglunhuikuiRewardApply);
// }


export async function applyByPinglunhuikui(formData) {
  // formData 必须是 FormData 实例 发送文件需要用post multipart/form-data
  const response = await api.post('coin/reward/apply/by/pinglunhuikui', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data; // 只返回后端 data 字段
}

// export async function applyByFenxiangguan(fenxiangguanRewardApply) {
//   return await sendRequest('coin/reward/apply/by/fenxiangguan', 'POST', fenxiangguanRewardApply);
// }

export async function applyByFenxiangguan(formData) {
  // formData 必须是 FormData 实例 发送文件需要用post multipart/form-data
  const response = await api.post('coin/reward/apply/by/fenxiangguan', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data; // 只返回后端 data 字段
}

export async function jingxinAdminLogin(loginObj) {
  return await sendRequest('admin/jingxin/access', 'POST', loginObj);
}


export async function getBusinessAnalysis(data) {
  return await sendRequest('app/data/business/analysis', 'POST', data);
}



export async function getPagedRewardApplyData(params) {
  
  return await sendRequest('coin/reward/get/award/apply/paged', 'GET', params);
}

export async function getPagedRewardApplyDataById(params) {
  
  return await sendRequest('coin/reward/get/award/apply/by/id', 'GET', params);
}


export async function approveAwardById(params) {
  return await sendRequest('coin/reward/approve/award/by/id', 'POST', params);
}


export async function deleteApprovedAwardById(params) {
  return await sendRequest('coin/reward/delete/approve/award/by/id', 'POST', params);
}




export async function uploadImageToServer(file, path) {
  const formData = new FormData();
  formData.append('file', file);
  if (path) {
    formData.append('path', path);
  }
  // 不做 try，异常交给调用方处理
  const response = await api.post('oss/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
}





export async function saveAudioLearnData(formData) {
  // formData 必须是 FormData 实例 发送文件需要用post multipart/form-data
  const response = await api.post('listening/audio/learn/data/save', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data; // 只返回后端 data 字段
}

